import { Injectable } from '@angular/core';

@Injectable()
export class EnvironmentService {
    public AUTHBASE_URL: string; //'http://localhost:47119/auth';
    public APPBASE_URL: string; //'http://localhost:5001';

    constructor() {
        this.loadUrls();
    }

    private loadUrls(): void {
        let hostname = window.location.hostname.replace(/^www\./, '');
        let protocol = window.location.protocol;
        let port = window.location.port;
        if (hostname.toLowerCase() == "localhost") {
            this.AUTHBASE_URL = 'http://localhost:47119/auth';
            this.APPBASE_URL = 'http://localhost:5001';
        }
        else {
            this.AUTHBASE_URL = protocol + '//' + hostname + '/auth';
            this.APPBASE_URL = protocol + '//apps.' + hostname;
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/services/environment.service.ts